import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

const TOOLTIP_WIDTH = 260;

export const summaryChips = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: space.s4,
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
});

const chipBase = style([
  typography.labelSm,
  {
    height: 20,
    padding: `0 ${space.s8}px`,
    gap: space.s4,
  },
]);

export const filterChip = style([chipBase, { minWidth: 0 }]);

export const overflowChip = style([chipBase, { flexShrink: 0 }]);

export const chipMode = style({
  opacity: 0.65,
  flexShrink: 0,
});

export const chipValue = style({
  minWidth: 0,
  maxWidth: 160,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const tooltipChips = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: space.s4,
  maxWidth: TOOLTIP_WIDTH,
});

export const tooltipChip = style([
  typography.labelSm,
  {
    maxWidth: TOOLTIP_WIDTH,
    alignItems: 'flex-start',
    height: 'auto',
    padding: `${space.s4}px ${space.s8}px`,
    gap: space.s4,
    whiteSpace: 'normal',
    borderRadius: borderRadius.r8,
    backgroundColor: themeVars.container.primary.background.idle,
    color: themeVars.container.foreground.primary,
    boxShadow: `0 0 0 1px ${themeVars.container.border.default}`,
  },
]);

// The tooltip reveals what the header truncated, so the value wraps in full
// here rather than ellipsising again.
export const tooltipChipValue = style({
  minWidth: 0,
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
});
